import { Box, Divider, Typography } from "@mui/material";
import CircleOption from "../../components/filterOption/CircleOption";

/**
 * Demo component for CircleOption
 * Shows different types and configurations of the CircleOption component
 */
const CircleOptionDemo = () => {
  return (
    <Box display="flex" flexDirection="column" gap={2}>
      {/* Status type */}
      <Box>
        <Typography variant="subtitle2" gutterBottom>
          Status Type:
        </Typography>
        <Box display="flex" flexDirection="row" gap={3} flexWrap="wrap">
          <CircleOption label="Gap" type="status" />
          <CircleOption label="Compliant" type="status" />
          <CircleOption label="Snoozed" type="status" />
          <CircleOption label="Excluded" type="status" />
        </Box>
      </Box>

      <Divider />

      {/* Priority type */}
      <Box>
        <Typography variant="subtitle2" gutterBottom>
          Priority Type:
        </Typography>
        <Box display="flex" flexDirection="row" gap={3} flexWrap="wrap">
          <CircleOption label="Lowest" type="priority" />
          <CircleOption label="Low" type="priority" />
          <CircleOption label="Medium" type="priority" />
          <CircleOption label="High" type="priority" />
          <CircleOption label="Highest" type="priority" />
        </Box>
      </Box>

      <Divider />

      {/* Feasibility type */}
      <Box>
        <Typography variant="subtitle2" gutterBottom>
          Feasibility Type:
        </Typography>
        <Box display="flex" flexDirection="row" gap={3} flexWrap="wrap">
          <CircleOption label="Very Low" type="feasibility" />
          <CircleOption label="Low" type="feasibility" />
          <CircleOption label="Medium" type="feasibility" />
          <CircleOption label="High" type="feasibility" />
          <CircleOption label="Very High" type="feasibility" />
        </Box>
      </Box>

      <Divider />

      {/* Jira Status type */}
      <Box>
        <Typography variant="subtitle2" gutterBottom>
          Jira Status:
        </Typography>
        <Box display="flex" flexDirection="row" gap={3} flexWrap="wrap">
          <CircleOption label="To Do" type="jiraStatus" />
          <CircleOption label="In Progress" type="jiraStatus" />
          <CircleOption label="Done" type="jiraStatus" />
        </Box>
      </Box>
    </Box>
  );
};

export default CircleOptionDemo;
